import { render } from "./VisitorAdults.vue?vue&type=template&id=1232040c"
import script from "./VisitorAdults.vue?vue&type=script&lang=js"
export * from "./VisitorAdults.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__